module.exports = __webpack_public_path__ + "img/coconut-cake.fbcfef54.png";